export class PaginationComponent {
 static config = {
  selector: 'afPagination',
  controller: PaginationComponent,
  bindings: {
   hidePag: '<',
   currentPage: '<',
   pageSize: '<',
   contentLength: '<',
   paginationTitle: '<',
   onPrevClicked: '&',
   onNextClicked: '&',
  },
  template: `
           <div class="pagination-container"
           ng-class="{'extra-height': $ctrl.hidePag}"
           ng-if="$ctrl.contentLength > $ctrl.pageSize">
                <hr style="color: rgba(0, 0, 0, 0.15); opacity: 0.3" ng-hide="$ctrl.hidePag">
                <section layout="row" layout-align="center center" ng-hide="$ctrl.hidePag">
                    <div>
                        <!--<mw-icon-button svg-icon="hardware:ic_keyboard_arrow_left_24px" hover="true" aria-label="previous page" tooltip="Previous" is-disabled="$ctrl.currentPage === 0" ng-click="$ctrl.currentPage !== 0 ? $ctrl.currentPage = $ctrl.currentPage-1 : null">
                        </mw-icon-button> -->

                        <mw-icon-button svg-icon="hardware:ic_keyboard_arrow_left_24px" hover="true" aria-label="previous page" tooltip="Previous" is-disabled="$ctrl.currentPage === 0" ng-click="$ctrl.onPrevClicked()">
                        </mw-icon-button>
                    </div>

                    <div style="font-size: 14px; color: rgba(0, 0, 0, 0.54)">
                        {{$ctrl.currentPage*$ctrl.pageSize+1}}-{{($ctrl.currentPage*$ctrl.pageSize+$ctrl.pageSize) > $ctrl.contentLength? $ctrl.contentLength : $ctrl.currentPage*$ctrl.pageSize+$ctrl.pageSize}} {{'mw-collection__table-pagination-of' | translate}} {{$ctrl.contentLength}} {{$ctrl.paginationTitle | translate}}
                    </div>

                    <div>
                        <mw-icon-button svg-icon="hardware:ic_keyboard_arrow_right_24px" hover="true" aria-label="next page" tooltip="Next" is-disabled="$ctrl.currentPage >= $ctrl.contentLength/$ctrl.pageSize - 1" ng-click="$ctrl.onNextClicked()"></mw-icon-button>
                    </div>
                </section>
            </div>
        `,
 }

 $onInit() {}
}
